(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-2"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const viewToggle = document.querySelector('[data-view-toggle]');
    const gridContainer = document.querySelector('.product-grid-container');

    if (!viewToggle || !gridContainer) return;

    const buttons = viewToggle.querySelectorAll('[data-view]');

    const applyViewToCards = (view) => {
      const cards = gridContainer.querySelectorAll('.product-grid__item');

      cards.forEach((card) => {
        const gallery = card.querySelector('.card-gallery') || card;
        if (!gallery) return;

        const images = gallery.querySelectorAll('img');
        if (images.length < 2) return;

        if (view === 'model') {
          images[0].style.display = 'none';
          images[1].style.display = '';
        } else {
          images[0].style.display = '';
          images[1].style.display = 'none';
        }
      });
    };

    const setActiveView = (view) => {
      buttons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.view === view);
      });
      applyViewToCards(view);
    };

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        setActiveView(btn.dataset.view);
      });
    });

    // initial state – default to Product (first image)
    setActiveView('product');

    // re-apply on AJAX updates (filters, pagination)
    const observer = new MutationObserver(() => {
      const activeBtn = viewToggle.querySelector('.is-active');
      const currentView = activeBtn ? activeBtn.dataset.view : 'product';
      applyViewToCards(currentView);
    });

    observer.observe(gridContainer, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
